<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>

    <b-card no-body>
      <b-card-body>
        <b-container class="bv-example-row">
          <div class="h4 m-1">
            เรทอัตราจ่าย
          </div>
          <b-form>
            <b-row class="d-flex justify-content-center">
              <b-col cols="6">
                <b-form-group>
                  <b-form-select
                    v-model="rateCode"
                    :options="rateCodeOptions"
                    value-field="code"
                    text-field="code"
                    @change="selectRate()"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="auto">
                <b-button
                  variant="success"
                  @click="saveRate"
                >
                  บันทึก
                </b-button>
              </b-col>
            </b-row>

            <!-- <b-row
              class="d-flex justify-content-center align-items-center text-center bg-light p-1 rounded mb-2 mx-1"
            >
              <b-col cols="4">
                <b-form-group label="สถานะ">
                  <b-form-checkbox switch v-model="status"></b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="ระดับ">
                  <b-form-checkbox
                    switch
                    v-model="level"
                    @change="toggleCollapse"
                  ></b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="อัตราเรท">
                  <b-form-select
                    class="w-auto"
                    v-model="selectedRate"
                    :options="rateOptions"
                    @change="toggleCollapse"
                  />
                </b-form-group>
              </b-col>
            </b-row> -->

            <b-tabs
              align="center"
              class="mt-2"
            >
              <b-tab
                active
                title="4 ตัวบน"
              >
                <lotto4UP
                  :is-collapsed="isCollapsed"
                  :items="U4"
                />
              </b-tab>

              <b-tab title="3 ตัวหน้า">
                <lotto3F
                  :is-collapsed="isCollapsed"
                  :items="F3"
                />
              </b-tab>
              <b-tab title="3 ตัวท้าย">
                <lotto3B
                  :is-collapsed="isCollapsed"
                  :items="B3"
                /></b-tab>
              <b-tab title="3 ตัวบน">
                <lotto3UP
                  :is-collapsed="isCollapsed"
                  :items="U3"
                /></b-tab>
              <b-tab title="3 ตัวโต๊ด">
                <lotto3TOT
                  :is-collapsed="isCollapsed"
                  :items="T3"
                /></b-tab>
              <b-tab title="2 ตัวบน">
                <lotto2UP
                  :is-collapsed="isCollapsed"
                  :items="U2"
                /></b-tab>
              <b-tab
                title="2 ตัวล่าง"
              ><lotto2Down
                :is-collapsed="isCollapsed"
                :items="D2"
              />
              </b-tab>
              <b-tab
                title="วิ่งบน"
              ><lottoRunUP
                :is-collapsed="isCollapsed"
                :items="U1"
              />
              </b-tab>
              <b-tab
                title="วิ่งล่าง"
              ><lottoRunDown
                :is-collapsed="isCollapsed"
                :items="D1"
              />
              </b-tab>
            </b-tabs>
          </b-form>
        </b-container>
      </b-card-body>
    </b-card>
    <b-modal
      v-model="showConfirmModal"
      title="ยืนยันการบันทึก"
      @ok.prevent="confirmSave"
      @cancel="cancelSave"
    >
      <p>คุณต้องการบันทึกข้อมูลเรทอัตราจ่ายหรือไม่?</p>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="success"
          @click="ok()"
        >
          ยืนยัน
        </b-button>
        <b-button
          variant="danger"
          @click="cancel()"
        >
          ยกเลิก
        </b-button>
      </template>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BButton,
  // BFormInput,
  BOverlay,
  BCardBody,
  BCard,
  // BFormCheckbox,
  BFormSelect,
  BContainer,
  BTab,
  BTabs,
  BModal,
  BIconController,
} from 'bootstrap-vue'

const lotto4UP = () => import('@/layouts/payoutrate/4up.vue')
const lotto3F = () => import('@/layouts/payoutrate/3f.vue')
const lotto3B = () => import('@/layouts/payoutrate/3b.vue')
const lotto3UP = () => import('@/layouts/payoutrate/3up.vue')
const lotto3TOT = () => import('@/layouts/payoutrate/3tot.vue')
const lotto2UP = () => import('@/layouts/payoutrate/2up.vue')
const lotto2Down = () => import('@/layouts/payoutrate/2down.vue')
const lottoRunUP = () => import('@/layouts/payoutrate/runup.vue')
const lottoRunDown = () => import('@/layouts/payoutrate/rundown.vue')
export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    // BFormInput,
    BOverlay,
    BCardBody,
    BCard,
    // BFormCheckbox,
    BFormSelect,
    BContainer,
    BTab,
    BTabs,
    BModal,
    BIconController,
    lotto4UP,
    lotto3F,
    lotto3B,
    lotto3UP,
    lotto3TOT,
    lotto2UP,
    lotto2Down,
    lottoRunUP,
    lottoRunDown,
  },
  data() {
    return {
      items4UP: [
        {
          rates: {
            betMax4Top: 500,
            pay4Top: 150,
            payMax4Top: 7500,
            roundbetMin4Top: 100,
            roundbetMax4Top: 1000,
            level: [
              { lvpayout: 23, percent: 100, total: 133 },
              { lvpayout: 23, percent: 65, total: 12 },
              { lvpayout: 23, percent: 30, total: 14 },
              { lvpayout: 23, percent: 30, total: 14 },
              { lvpayout: 23, percent: 100, total: 133 },
              { lvpayout: 23, percent: 65, total: 12 },
              { lvpayout: 23, percent: 30, total: 14 },
              { lvpayout: 23, percent: 30, total: 14 },
              { lvpayout: 23, percent: 100, total: 133 },
              { lvpayout: 23, percent: 65, total: 12 },

            ],
          },
        },
      ],
      show: true,
      showConfirmModal: false,
      rateCode: null,
      status: false,
      level: false,
      selectedRate: null,
      isCollapsed: false,
      rateCodeOptions: [],
      rateOptions: [
        { value: null, text: 'เลือกเรท', disabled: true },
        { value: 'rate1', text: 'เรท 1' },
        { value: 'rate2', text: 'เรท 2' },
      ],
      U4: {
        U4MaxBet: 0,
        U4MaxLimit: 0,
        U4MinBet: 0,
        U4Pay: 0,
        U4StepPay: [],
        U4StepPct: [],
      },
      U3: {
        U3MaxBet: 0,
        U3MaxLimit: 0,
        U3MinBet: 0,
        U3Pay: 0,
        U3StepPay: [],
        U3StepPct: [],
      },
      F3: {
        F3MaxBet: 0,
        F3MaxLimit: 0,
        F3MinBet: 0,
        F3Pay: 0,
        F3StepPay: [],
        F3StepPct: [],
      },
      B3: {
        B3MaxBet: 0,
        B3MaxLimit: 0,
        B3MinBet: 0,
        B3Pay: 0,
        B3StepPay: [],
        B3StepPct: [],
      },
      T3: {
        T3MaxBet: 0,
        T3MaxLimit: 0,
        T3MinBet: 0,
        T3Pay: 0,
        T3StepPay: [],
        T3StepPct: [],
      },
      U2: {
        U2MaxBet: 0,
        U2MaxLimit: 0,
        U2MinBet: 0,
        U2Pay: 0,
        U2StepPay: [],
        U2StepPct: [],
      },
      D2: {
        D2MaxBet: 0,
        D2MaxLimit: 0,
        D2MinBet: 0,
        D2Pay: 0,
        D2StepPay: [],
        D2StepPct: [],
      },
      U1: {
        U1MaxBet: 0,
        U1MaxLimit: 0,
        U1MinBet: 0,
        U1Pay: 0,
        U1StepPay: [],
        U1StepPct: [],
      },
      D1: {
        D1MaxBet: 0,
        D1MaxLimit: 0,
        D1MinBet: 0,
        D1Pay: 0,
        D1StepPay: [],
        D1StepPct: [],
      },
    }
  },
  // watch: {
  //   isCollapsed(newValue) {
  //     if (newValue === true) {
  //       this.level = true;
  //     } else {
  //       this.level = false;
  //       this.selectedRate = null;
  //     }
  //   },
  // },
  computed: {},
  async mounted() {
    await this.ratelimitData()
    this.getRate()
  },
  methods: {
    async ratelimitData() {
      const { data: res } = await this.$http.get('common/ratelimit')
      this.rateCodeOptions = res.data
    },
    getRate() {
      this.show = true
      this.$http.get('Agent/getRate').then(response => {
        if (response.data && response.data.lotto_rate) {
          this.rateCode = response.data.lotto_rate
          const Datarate = this.rateCodeOptions.find(ele => ele.code == this.rateCode)
          if (Datarate) {
            this.U4 = {
              U4MaxBet: Datarate.U4MaxBet,
              U4MaxLimit: Datarate.U4MaxLimit,
              U4MinBet: Datarate.U4MinBet,
              U4Pay: Datarate.U4Pay,
              U4StepPay: Datarate.U4StepPay,
              U4StepPct: Datarate.U4StepPct,
            }
            this.F3 = {
              F3MaxBet: Datarate.F3MaxBet,
              F3MaxLimit: Datarate.F3MaxLimit,
              F3MinBet: Datarate.F3MinBet,
              F3Pay: Datarate.F3Pay,
              F3StepPay: Datarate.F3StepPay,
              F3StepPct: Datarate.F3StepPct,
            }
            this.B3 = {
              B3MaxBet: Datarate.B3MaxBet,
              B3MaxLimit: Datarate.B3MaxLimit,
              B3MinBet: Datarate.B3MinBet,
              B3Pay: Datarate.B3Pay,
              B3StepPay: Datarate.B3StepPay,
              B3StepPct: Datarate.B3StepPct,
            }
            this.T3 = {
              T3MaxBet: Datarate.T3MaxBet,
              T3MaxLimit: Datarate.T3MaxLimit,
              T3MinBet: Datarate.T3MinBet,
              T3Pay: Datarate.T3Pay,
              T3StepPay: Datarate.T3StepPay,
              T3StepPct: Datarate.T3StepPct,
            }
            this.U3 = {
              U3MaxBet: Datarate.U3MaxBet,
              U3MaxLimit: Datarate.U3MaxLimit,
              U3MinBet: Datarate.U3MinBet,
              U3Pay: Datarate.U3Pay,
              U3StepPay: Datarate.U3StepPay,
              U3StepPct: Datarate.U3StepPct,
            }
            this.U2 = {
              U2MaxBet: Datarate.U2MaxBet,
              U2MaxLimit: Datarate.U2MaxLimit,
              U2MinBet: Datarate.U2MinBet,
              U2Pay: Datarate.U2Pay,
              U2StepPay: Datarate.U2StepPay,
              U2StepPct: Datarate.U2StepPct,
            }
            this.D2 = {
              D2MaxBet: Datarate.D2MaxBet,
              D2MaxLimit: Datarate.D2MaxLimit,
              D2MinBet: Datarate.D2MinBet,
              D2Pay: Datarate.D2Pay,
              D2StepPay: Datarate.D2StepPay,
              D2StepPct: Datarate.D2StepPct,
            }
            this.U1 = {
              U1MaxBet: Datarate.U1MaxBet,
              U1MaxLimit: Datarate.U1MaxLimit,
              U1MinBet: Datarate.U1MinBet,
              U1Pay: Datarate.U1Pay,
              U1StepPay: Datarate.U1StepPay,
              U1StepPct: Datarate.U1StepPct,
            }
            this.D1 = {
              D1MaxBet: Datarate.D1MaxBet,
              D1MaxLimit: Datarate.D1MaxLimit,
              D1MinBet: Datarate.D1MinBet,
              D1Pay: Datarate.D1Pay,
              D1StepPay: Datarate.D1StepPay,
              D1StepPct: Datarate.D1StepPct,
            }
            this.isCollapsed = Datarate.tieredPayout
          }
          this.show = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    selectRate() {
      this.show = true
      const Datarate = this.rateCodeOptions.find(ele => ele.code == this.rateCode)
      if (Datarate) {
        this.U4 = {
          U4MaxBet: Datarate.U4MaxBet,
          U4MaxLimit: Datarate.U4MaxLimit,
          U4MinBet: Datarate.U4MinBet,
          U4Pay: Datarate.U4Pay,
          U4StepPay: Datarate.U4StepPay,
          U4StepPct: Datarate.U4StepPct,
        }
        this.F3 = {
          F3MaxBet: Datarate.F3MaxBet,
          F3MaxLimit: Datarate.F3MaxLimit,
          F3MinBet: Datarate.F3MinBet,
          F3Pay: Datarate.F3Pay,
          F3StepPay: Datarate.F3StepPay,
          F3StepPct: Datarate.F3StepPct,
        }
        this.B3 = {
          B3MaxBet: Datarate.B3MaxBet,
          B3MaxLimit: Datarate.B3MaxLimit,
          B3MinBet: Datarate.B3MinBet,
          B3Pay: Datarate.B3Pay,
          B3StepPay: Datarate.B3StepPay,
          B3StepPct: Datarate.B3StepPct,
        }
        this.T3 = {
          T3MaxBet: Datarate.T3MaxBet,
          T3MaxLimit: Datarate.T3MaxLimit,
          T3MinBet: Datarate.T3MinBet,
          T3Pay: Datarate.T3Pay,
          T3StepPay: Datarate.T3StepPay,
          T3StepPct: Datarate.T3StepPct,
        }
        this.U3 = {
          U3MaxBet: Datarate.U3MaxBet,
          U3MaxLimit: Datarate.U3MaxLimit,
          U3MinBet: Datarate.U3MinBet,
          U3Pay: Datarate.U3Pay,
          U3StepPay: Datarate.U3StepPay,
          U3StepPct: Datarate.U3StepPct,
        }
        this.U2 = {
          U2MaxBet: Datarate.U2MaxBet,
          U2MaxLimit: Datarate.U2MaxLimit,
          U2MinBet: Datarate.U2MinBet,
          U2Pay: Datarate.U2Pay,
          U2StepPay: Datarate.U2StepPay,
          U2StepPct: Datarate.U2StepPct,
        }
        this.D2 = {
          D2MaxBet: Datarate.D2MaxBet,
          D2MaxLimit: Datarate.D2MaxLimit,
          D2MinBet: Datarate.D2MinBet,
          D2Pay: Datarate.D2Pay,
          D2StepPay: Datarate.D2StepPay,
          D2StepPct: Datarate.D2StepPct,
        }
        this.U1 = {
          U1MaxBet: Datarate.U1MaxBet,
          U1MaxLimit: Datarate.U1MaxLimit,
          U1MinBet: Datarate.U1MinBet,
          U1Pay: Datarate.U1Pay,
          U1StepPay: Datarate.U1StepPay,
          U1StepPct: Datarate.U1StepPct,
        }
        this.D1 = {
          D1MaxBet: Datarate.D1MaxBet,
          D1MaxLimit: Datarate.D1MaxLimit,
          D1MinBet: Datarate.D1MinBet,
          D1Pay: Datarate.D1Pay,
          D1StepPay: Datarate.D1StepPay,
          D1StepPct: Datarate.D1StepPct,
        }
        this.isCollapsed = Datarate.tieredPayout
      }
      this.show = false
    },
    confirmSave() {
      const obj = {
        code: this.rateCode,
      }
      this.$http.post('Agent/SaveRateLimit', obj).then(response => {
        if (response.data) {
          this.getRate()
          this.showConfirmModal = false
        }
      })
    },
    saveRate() {
      this.showConfirmModal = true
    },
    cancelSave() {
      this.showConfirmModal = false
    },
    //   toggleCollapse(item) {
    //     if (item === true) {
    //       this.isCollapsed = true;
    //     } else if (item === false) {
    //       this.isCollapsed = false;
    //     } else if (item !== null) {
    //       this.isCollapsed = true;
    //     } else {
    //       this.isCollapsed = false;
    //     }
    //   },
  },
}
</script>

<style lang="scss"></style>
